import React from "react"
import DayPicker, { DateUtils } from "react-day-picker";
import moment from "moment";
import MomentLocaleUtils,{ formatDate, parseDate } from "react-day-picker/moment";
import Helmet from "react-helmet";
import "moment/locale/it";

import "react-day-picker/lib/style.css";
import Helpers, { isSelected, isChecked, periods, months, views, leadtime_chart, status_reserve, days, options_compare, current_year, past_year, componentActive, subComponentActive, isPickupSection } from "../config/Helpers";


class FiltersTime extends React.Component{
  constructor(props){
    super(props);

    this.state = {
      active_week : 1,
      days_pickup : {
          base : 7,
          range : 7
      },
      request_status : "hide",
      module_menu_show : "hide",
      panel_menu_show : "hide",
      datepicker : { from : undefined,  to : undefined },
      datepicker_comp : { from : undefined,  to : undefined },
      datepicker_aux : { from : undefined,  to : undefined },
      datepicker_comp_aux : { from : undefined,  to : undefined },
      locale                    : "en",
      period_menu_show          : "hide-panel",
      views_menu_show           : "hide-panel",
      status_menu_show          : "hide-panel",
      days_menu_show            : "hide-panel",
      comp_menu_show            : "hide-panel",
      years_menu_show           : "hide-panel",
      dias_menu_show            : "hide-panel",
      past_dias_menu_show       : "hide-panel",
      compare_menu_options      : "hide-panel",
      past_menu_years_show      : "hide-panel",
      menu_chart_review         : "hide-panel",
      menu_chart_reservation    : "hide-panel",
      cust_menu_show            : "hide", //[Pruebas] Debe ser "hide"
      datepicker_compare        : "hide", //[Pruebas] Debe ser "hide"
      cont_datepicker           : "hide", //[Pruebas] Debe ser "hide"
      period_show               : "hide-panel",
      current_period            : { key : "Año en curso", value : "current_year" },
      current_period_aux        : { key : "Año en curso", value : "current_year" },
      current_view_review       : { key : "Meses", value : "month" },
      current_year              : { key : "2018", value : 2018 },
      current_year_compare      : { key : "2017", value : 2017 },
      current_status : { key : "Reservation Date", value : "date_nights" },
      current_comp : { key : "Periodo anterior", value : 0 },
      current_option_compare : { key : "Por año", value : "past_year" },
      current_view_leadtime : { key : "Room Nigths", value : "room_night" },
      current_view_reservation : { key : "Room Nigths", value : "room_night" },
      month_select : new Date(current_year(),0),
      month_select_last : new Date(past_year(),0),
      from_month_current : new Date(current_year(),0),
      from_month_past : new Date(past_year(),0),
      to_month_current : new Date(current_year(),11),
      to_month_past : new Date(past_year(),11),
      years : [ 2018, 2017, 2016],
      past_years : [ 2017, 2016, 2015],
      year_active : current_year(),
      past_year_active : past_year(),
      active_days : {},
      request_status : "hide"
    };

    this.handleDayClick             = this.handleDayClick.bind(this);
    this.handleDayClickPast         = this.handleDayClickPast.bind(this);
    this.handleResetClick           = this.handleResetClick.bind(this);
    this.state.datepicker           = this.getInitialState();
    this.state.datepicker_comp      = this.getInitialState();
    this.state.setRangeCustom       = this.setRangeCustom();
    this.state.changeDatesByYear    = this.changeDatesByYear();
    this.getResetValues = this.getResetValues.bind(this)

    }   
    getResetValues(){
        return {
            active_week : 1,
            days_pickup : {
                base : 7,
                range : 7
            },
            request_status : "hide",
            module_menu_show : "hide",
            panel_menu_show : "hide",
            datepicker : { from : undefined,  to : undefined },
            datepicker_comp : { from : undefined,  to : undefined },
            datepicker_aux : { from : undefined,  to : undefined },
            datepicker_comp_aux : { from : undefined,  to : undefined },
            locale                    : "en",
            period_menu_show          : "hide-panel",
            views_menu_show           : "hide-panel",
            status_menu_show          : "hide-panel",
            days_menu_show            : "hide-panel",
            comp_menu_show            : "hide-panel",
            years_menu_show           : "hide-panel",
            dias_menu_show            : "hide-panel",
            past_dias_menu_show       : "hide-panel",
            compare_menu_options      : "hide-panel",
            past_menu_years_show      : "hide-panel",
            menu_chart_review         : "hide-panel",
            menu_chart_reservation    : "hide-panel",
            cust_menu_show            : "hide", //[Pruebas] Debe ser "hide"
            datepicker_compare        : "hide", //[Pruebas] Debe ser "hide"
            cont_datepicker           : "hide", //[Pruebas] Debe ser "hide"
            period_show               : "hide-panel",
            current_period            : { key : "Año en curso", value : "current_year" },
            current_period_aux        : { key : "Año en curso", value : "current_year" },
            current_view_review       : { key : "Meses", value : "month" },
            current_year              : { key : "2018", value : 2018 },
            current_year_compare      : { key : "2017", value : 2017 },
            current_status : { key : "Reservation Date", value : "date_nights" },
            current_comp : { key : "Periodo anterior", value : 0 },
            current_option_compare : { key : "Por año", value : "past_year" },
            current_view_leadtime : { key : "Room Nigths", value : "room_night" },
            current_view_reservation : { key : "Room Nigths", value : "room_night" },
            month_select : new Date(current_year(),0),
            month_select_last : new Date(past_year(),0),
            from_month_current : new Date(current_year(),0),
            from_month_past : new Date(past_year(),0),
            to_month_current : new Date(current_year(),11),
            to_month_past : new Date(past_year(),11),
            years : [ 2018, 2017, 2016],
            past_years : [ 2017, 2016, 2015],
            year_active : current_year(),
            past_year_active : past_year(),
            active_days : {},
            request_status : "hide"
        }
    }
    getInitialState() {
        return {
            from: undefined,
            to: undefined,
        };
    }

    getDefaultValues(){
        return {
            current_view_preview    : { 
              key   : "Meses", 
              value : "month", 
            },
            current_period  : { 
              key   : "Año en curso", 
              value : "current_year" 
            },
            current_view_reservation   : { 
              key : "Room Nigths", 
              value : "room_night" 
            },
            current_view_leadtime   : { 
              key : "Room Nigths", 
              value : "room_night" 
            },
            cust_menu_show          : "hide",
            datepicker_compare      : "hide", 
            cont_datepicker         : "hide",
            year_active             : current_year(),
            past_year_active        : past_year(),
            active_days             : {},
            active_week : 1,
            days_pickup        : {
                base : 7,
                range : 7
            },
            current_year            : { 
              key : "2018", 
              value : 2018 
            },
            current_year_compare    : { 
              key : "2017", 
              value : 2017 
            },
            current_option_compare  : {
               key : "Por año", 
               value : "past_year" 
              }
          };
    }
    changeDatesByYear(type_select, value){
        let from_date_current   = new Date(value, 0),
            to_date_current     = new Date(value, 11),
            from_current        = this.state.datepicker.from !== undefined ? new Date(this.state.datepicker.from) : undefined,
            to_current          = this.state.datepicker.to !== undefined ? new Date(this.state.datepicker.to) : undefined,
            from_date_past      = new Date( value, 0),
            to_date_past        = new Date( value, 11),
            from_comp           = this.state.datepicker_comp.from !== undefined ? new Date(this.state.datepicker_comp.from) : undefined,
            to_comp             = this.state.datepicker_comp.to !== undefined ? new Date(this.state.datepicker_comp.to) : undefined,
            current_year_aux, comp_year_aux;
        
        if(type_select === "current"){
            current_year_aux = value;
            if(this.state.current_year_compare.value >= value){
                comp_year_aux = this.state.current_year_compare.value - 1;
            }else{
                comp_year_aux = this.state.current_year_compare.value;
            }   
        }else if(type_select === "compare"){
            comp_year_aux = value;
            if(this.state.current_year.value <= value){
                current_year_aux = this.state.current_year.value + 1;
            }else{
                current_year_aux = this.state.current_year.value;
            }  
        }
        if(from_current !== undefined){
            from_current.setFullYear(current_year_aux)
        }
        if(to_current !== undefined ){
            to_current.setFullYear(current_year_aux)    
        } 
        if(from_comp !== undefined){
            from_comp.setFullYear(comp_year_aux)
        }
        if(to_comp !== undefined ){
            to_comp.setFullYear(comp_year_aux)    
        } 

        from_date_current.setFullYear(current_year_aux)
        to_date_current.setFullYear(current_year_aux)
        
        from_date_past.setFullYear(comp_year_aux)
        to_date_past.setFullYear(comp_year_aux)

        this.setState(function(){
            return {
                year_active             : current_year_aux,
                past_year_active        : comp_year_aux,
                month_select            : from_date_current,
                month_select_last       : from_date_past,
                from_month_current      : from_date_current,
                from_month_past         : from_date_past,
                to_month_current        : to_date_current,
                to_month_past           : to_date_past,
                datepicker              : {
                    from : from_current,
                    to   : to_current
                },
                datepicker_comp : {
                    from : from_comp,
                    to   : to_comp
                },
                current_year            : { key : current_year_aux, value : current_year_aux },
                current_year_compare    : { key : comp_year_aux, value : comp_year_aux }
            }
        })
    }
    setRangeCustom(value, _default = false){
        this.props.app.setState({
            period_filter : value
        });

        let from_current  = new Date(),
        to_current        = new Date(),
        from_past         = new Date(),
        to_past           = new Date();
        
        this.setState({
            year_active : (_default === true) ? current_year() : this.state.current_year,
            past_year_active : (_default === true) ? past_year() : this.state.past_year_active,
            current_year : { 
                key : (_default === true) ? current_year() : this.state.current_year.key, 
                value : (_default === true) ? current_year() : this.state.current_year.value 
            },
            current_year_compare : { 
                key : (_default === true) ? past_year() : this.state.current_year_compare.key, 
                value : (_default === true) ? past_year() : this.state.current_year_compare.value
            }
        }, function(){
            from_past.setFullYear(this.state.past_year_active)
            to_past.setFullYear(this.state.past_year_active)
        })
        

        if(value === "today")
        {
            this.setState({year_active  : current_year() })
        }
        else if(value === "yesterday"){
            from_current.setDate(from_current.getDate() - 1)
            to_current.setDate(to_current.getDate() - 1)     
            from_past.setDate(from_past.getDate() - 1)
            to_past.setDate(to_past.getDate() - 1);

            this.setState({year_active  : current_year() })
            
        }else if(value === "acm"){
            from_current    = new Date(current_year(),0,1)        
            from_past       = new Date((this.state.past_year_active),0,1)
            this.setState({year_active  : current_year() })

        }
        else if(value === "current_year"){
            from_current    = new Date(current_year(), 0,1)
            to_current      = new Date(current_year(), 11,31)          
            from_past       = new Date((current_year() - 1), 0,1)
            to_past         = new Date((current_year() - 1), 11,31)
            this.setState({year_active  : current_year() })
        }else if( value === "choice"){
            from_current    = undefined;
            to_current      = undefined;          
            from_past       = undefined;
            to_past         = undefined;
        }else if(value === "pickup"){
            let max_book_date = this.props.app.state.max_book_date.split(" ");
            max_book_date = max_book_date[0];

            to_current = new Date(max_book_date);
            to_current.setDate(to_current.getDate());
            from_current = new Date(max_book_date);
            from_current.setDate(from_current.getDate() - (this.state.days_pickup.range - 1));  
            
            to_past = new Date(max_book_date)
            to_past.setFullYear(to_past.getFullYear() - 1);
            to_past.setDate(to_past.getDate());

            from_past = new Date(max_book_date);
            from_past.setFullYear(from_past.getFullYear() - 1);
            from_past.setDate(from_past.getDate() - (this.state.days_pickup.range - 1));

            this.setState({
                year_active : current_year(),
                cust_menu_show : "hide",
                period_show : "hide-panel", 
                datepicker_compare : "hide"
            })
        }
        if(value === "custom")
        {
            this.setState({
                cont_datepicker     :   "",
                month_select        :   to_current,
                month_select_last   :   to_past,
                current_year        :   { 
                    key     : from_current.getFullYear(), 
                    value   : from_current.getFullYear() 
                }
            }, function(){
                this.props.app.activeCustomCalendar(this.state.cont_datepicker);
            })
        }else if(value === "custom-aux")
        {
            this.props.app.hideSelects();
            let datepicker = Object.assign({}, this.state.datepicker_aux);
            let datepicker_comp = Object.assign({}, this.state.datepicker_comp_aux);
            if(this.state.cont_datepicker === ""){        
                this.state.datepicker = { to : new Date(datepicker.to), from : new Date(datepicker.from) }
                this.state.datepicker_comp = { to : new Date(datepicker_comp.to), from : new Date(datepicker_comp.from) }
            }
            let from_month_current = new Date(this.state.datepicker.from);
            from_month_current.setMonth(0);
            let to_month_current = new Date(this.state.datepicker.to);
            to_month_current.setMonth(11);
            let month_select = new Date(this.state.datepicker.from);
            
            this.setState({
                cont_datepicker : this.state.cont_datepicker === "" ? "hide" : "",
                month_select : month_select,
                cust_menu_show : this.state.cont_datepicker === "" ? "hide" : "",
                from_month_current : from_month_current,
                to_month_current : to_month_current,

            }, function(){
                this.props.app.activeCustomCalendar(this.state.cont_datepicker);
            })
        }else if(value !== "choice"){
            this.setState({
                cont_datepicker :   "hide",
                datepicker      : {
                    to      : to_current,
                    from    : from_current
                },
                datepicker_comp : {
                    to      : to_past,
                    from    : from_past
                },
                datepicker_aux      : {
                    to      : to_current,
                    from    : from_current
                },
                datepicker_comp_aux : {
                    to      : to_past,
                    from    : from_past
                },
                current_period_aux : this.state.current_period
            }, function(){
                const years_compare = [ this.state.year_active, this.state.past_year_active]
                this.props.app.activeCustomCalendar(this.state.cont_datepicker);
                this.props.app.setFilterBubble(null, [this.state.datepicker.from, this.state.datepicker.to, this.state.datepicker_comp.from, this.state.datepicker_comp.to],null, "time", null, this.state.active_days, years_compare);

            })
        }
    }
    handleDayClickPast(day) {
        let day_last_year = new Date(day);
        let year          = day_last_year.getFullYear();
        let year_last     = this.state.past_year_active;
        
        day_last_year.setFullYear(this.state.past_year_active)

        this.setState({ 
            month_select_last   :  new Date(year_last, day_last_year.getMonth())
        })
        if(this.state.current_period.key !== "Personalizado"){
            this.setState({
                current_period  : { key : "Personalizado", value : "custom"}, 
                datepicker_comp : { from : undefined,  to : undefined }
            }, () => {
                const range_comp = DateUtils.addDayToRange(day_last_year, this.state.datepicker_comp);
                this.setState({datepicker_comp : range_comp});
            });
        }else{
            
            const range_comp = DateUtils.addDayToRange(day_last_year, this.state.datepicker_comp);
            this.setState({datepicker_comp : range_comp});
        }
    }
    handleDayClick(day) {

        let day_last_year = new Date(day);
        let year          = day_last_year.getFullYear();        
        day_last_year.setFullYear(this.state.past_year_active)

        this.setState({ 
            month_select        :  new Date(year, day_last_year.getMonth()),
        })
        if(this.state.current_period.key !== "Personalizado"){
            this.setState({
                current_period  : { key : "Personalizado", value : "custom"}, 
                datepicker      : { from : undefined,  to : undefined },
            },function(){
                const range = DateUtils.addDayToRange(day, this.state.datepicker);
                this.setState({ datepicker : range });
            });
        }else{
            const range = DateUtils.addDayToRange(day, this.state.datepicker);
            this.setState({ datepicker : range });
        }
    }

    handleResetClick(){
        this.setState({ 
            datepicker : this.getInitialState(), 
            datepicker_comp : this.getInitialState()
        });
    }
    handleClickMenu(name) {
        let current_period = this.state.current_period
        if(name !== "dias_menu_show" && name !== "years_menu_show" && name !== "comp_menu_show" && name !== "past_menu_years_show" && name !== "compare_menu_options" && name !== "past_dias_menu_show"){
            this.props.app.hideSelects();
        }else if(name === "period_menu_show"){
            this.props.app.hideSelects("calendar_widget_active");
        }else{
            this.props.app.hideSelects("calendar_widget");
        }

        this.setState(function(){
            return { 
                [name] :  (this.state[name] === "hide-panel" ? "" : "hide-panel")
            }
        })
        
    }
    handleClickMenuItem(keyText, valueText, menu) {
        
        let $self = this;
        switch (menu) {
            case "period_menu":
                this.setState({ 
                    current_period : { 
                        key : keyText, value : valueText 
                    } 
                }, () => this.setRangeCustom(valueText))
            break;
            case "views_menu":
                this.setState({ 
                    current_view_review : { 
                        key : keyText, value : valueText 
                    } 
                }, () => $self.props.app.setViewList(valueText))
            break;
            case "reservation_chart_menu":
                this.setState({ 
                    current_view_reservation : { 
                        key : keyText, value : valueText 
                    } 
                }, () => $self.props.app.setViewList(valueText))
            break;

            case "leadtime_chart_menu":
                this.setState({ 
                    current_view_leadtime : { 
                        key : keyText, value : valueText 
                    } 
                }, () => $self.props.app.setViewList(valueText))
            break;
            case "status_menu":
                this.setState({
                    current_status : { 
                        key : keyText, value : valueText 
                    } 
                }, () => this.props.app.setTypeDateQuery(valueText))
            break;
            case "comp_menu":
                this.setState({
                    current_comp : { 
                        key : keyText, value : valueText 
                    } 
                })
            break;
            case "comp_year":
                this.changeDatesByYear('current', valueText)
            break;
            case "comp_past_year":
                this.changeDatesByYear('compare', valueText)
            break;
            case "custom_compare":
                this.setState({
                    current_option_compare : { key : keyText, value : valueText } 
                }, () => {
                    if(valueText === "custom_past_year"){
                        this.setState({ datepicker_compare : '' })
                    }else{
                        this.setState({ datepicker_compare : 'hide' })
                    }
                })
            break;
            case "days":
                let array_elements  = this.state.active_days

                if(array_elements[valueText] === undefined){
                    array_elements[valueText] = { day : keyText, value : valueText }
                }else{
                    delete array_elements[valueText];
                }
                this.setState({
                    active_days : array_elements,
                })
            break;
        }
    }

    handleClickApply(type){
        let condition;
        if(type !== "cancel" && type !== "hide-select"){
            if(this.state.current_option_compare.value !== "custom_past_year")
            {
                condition = (
                    this.state.datepicker.from !== undefined && 
                    this.state.datepicker.to !== undefined
                );
            }else{
                condition = (
                    this.state.datepicker.from !== undefined && 
                    this.state.datepicker.to !== undefined && 
                    this.state.datepicker_comp.from !== undefined && 
                    this.state.datepicker_comp.to !== undefined
                );
            }
            if(condition){
                if(isPickupSection(this.props.app)){
                    let to_past = new Date(this.state.datepicker.to)
                    to_past.setFullYear(past_year());
                    to_past.setDate(to_past.getDate());

                    let from_past = new Date(this.state.datepicker.from);
                    from_past.setFullYear(past_year());
                    from_past.setDate(from_past.getDate());

                    this.state.datepicker = this.state.datepicker
                    this.state.datepicker_aux = this.state.datepicker
                    this.state.datepicker_comp = { to : to_past, from: from_past}
                    this.state.datepicker_comp_aux = { to : to_past, from: from_past}

                    let moment_from = moment(this.state.datepicker.from)
                    let moment_to = moment(this.state.datepicker.to)

                    this.state.days_pickup = { 
                        range : (moment_to.diff(moment_from,"days") + 1), 
                        base : (moment_to.diff(moment_from,"days") + 1)
                    }
                    this.state.active_week  = 1;
                }
                this.setState({ 
                    period_show     : "hide-panel",
                    cust_menu_show  : "hide",
                    cont_datepicker  : "hide",
                    current_period_aux  :  { key : "Personalizado" , value: "custom" },
                    current_year :   { 
                        key     : this.state.datepicker.from.getFullYear(), 
                        value   : this.state.datepicker.from.getFullYear() 
                    },
                    current_year_compare :   { 
                        key     : this.state.datepicker_comp.from.getFullYear(), 
                        value   : this.state.datepicker_comp.from.getFullYear() 
                    },
                    year_active : this.state.datepicker.from.getFullYear(),
                    past_year_active : this.state.datepicker_comp.from.getFullYear()
                }, function(){
                    const years_compare = [ this.state.year_active, this.state.past_year_active]
                    this.props.app.activeSecondaryBar("inactive");
                    this.props.app.activeCustomCalendar(this.state.cont_datepicker);
                    this.props.app.setFilterBubble(null, [this.state.datepicker.from, this.state.datepicker.to, this.state.datepicker_comp.from, this.state.datepicker_comp.to], null, "time", null, this.state.active_days, years_compare);
                });
            }else{
                this.props.app.alertState("datepicker")
            }
        }else if(type === "cancel"){
            this.props.app.hideSelects("calendar_widget_active")
        }else if(type === "hide-select"){
            this.setState(function(prevState){
                return { 
                    current_period  : prevState.current_period_aux,
                    datepicker      : prevState.datepicker_aux,
                    datepicker_comp : prevState.datepicker_comp_aux
                }
            }, () => this.props.app.activeCustomCalendar("hide"));
        }
    }

    handleClickFilterReset(type) {
        if(type === 2){
            if(this.state.cust_menu_show !== "hide"){
                this.setState({ 
                    period_show     : "hide-panel", 
                    cust_menu_show  : "hide" 
                }, () => this.props.app.activeCustomCalendar(this.state.cust_menu_show))
            }
            this.props.app.getInitialStatics("reset");
        }
    }

    handleClickShowCustomPeriods() {
        this.props.app.hideSelects();
        let temp_days       = Object.assign({}, this.props.app.current_filter_days);
        let cont_datepicker = this.state.current_period.value !== "custom" ? "hide" : ""; 
        if (this.state.period_show === "hide-panel"){
            this.props.app.activeSecondaryBar("active");
            this.setState({ 
                period_show         : "",
                cust_menu_show      : "",
                active_days         : temp_days
            }, () => this.props.app.activeCustomCalendar(this.state.cont_datepicker))
        }else{
            this.props.app.activeSecondaryBar("inactive");
            this.setState({ 
                period_show         : "hide-panel",
                cust_menu_show      : "hide",
                active_days         : {},
                cont_datepicker     : cont_datepicker,
            }, () => this.props.app.activeCustomCalendar("hide"))
        }
    }
    activeWeek(value){
        if(value !== this.state.active_week){
            const range = this.state.days_pickup.base * value;
            this.setState({
                days_pickup : {
                    range : range,
                    base : this.state.days_pickup.base
                },
                active_week : value
            }, function(){
                this.setPeriod('add')
            })
        }
    }
    validRange(value){
        if(value !== 1){
            let from_current = new Date(this.state.datepicker.from);
            from_current.setDate(from_current.getDate() - (this.state.days_pickup.base * value))
            if(from_current.getFullYear() !== this.props.app.state.current_year){
                return false;
            }
        }
        return true;        
    }
    getWeeks(){
        let weeks = [1,2,3,4].map((value) => (
            <span 
                className={ "week-select " + (this.state.active_week === value ? "active" : "") + (this.validRange(value) ? "" : " disabled") } 
                onClick={ () => { if(this.validRange(value)) { this.activeWeek(value)} } }
                children={value} />
            )
        );
        return weeks;  
    }

    setPeriod(action){
        let datepicker = Object.assign({}, this.state.datepicker_aux);
        let datepicker_comp = Object.assign({}, this.state.datepicker_comp_aux);
        if(action === "prev"){
            datepicker.to.setDate(datepicker.to.getDate() - this.state.days_pickup.range);
            let to_current = new Date(datepicker.to);
            to_current.setDate(to_current.getDate() - this.state.days_pickup.range)
            datepicker.from = to_current;
            
            datepicker_comp.to.setDate(datepicker_comp.to.getDate() - this.state.days_pickup.range);
            let to_past = new Date(datepicker_comp.to);
            to_past.setDate(to_past.getDate() - this.state.days_pickup.range)
            datepicker_comp.from = to_past;

        }else if(action === "next"){
            datepicker.from = new Date(datepicker.to);
            datepicker.to.setDate(datepicker.to.getDate() + this.state.days_pickup.range);

            datepicker_comp.from = new Date(datepicker_comp.to);
            datepicker_comp.to.setDate(datepicker_comp.to.getDate() + this.state.days_pickup.range);
                        
            
        }else if(action === "add"){
            
            let from_current = new Date(datepicker.to)
            from_current.setDate(from_current.getDate() - this.state.days_pickup.range);  

            let from_past = new Date(datepicker_comp.to);
            from_past.setDate(from_past.getDate() - this.state.days_pickup.range);

            datepicker.from = from_current
            datepicker_comp.from = from_past
        }
        this.setState({
            datepicker : datepicker,
            datepicker_comp : datepicker_comp
        }, function(){
            const years_compare = [ this.state.year_active, this.state.past_year_active]
            this.props.app.setFilterBubble(null, [this.state.datepicker.from, this.state.datepicker.to, this.state.datepicker_comp.from, this.state.datepicker_comp.to],null, "time", null, this.state.active_days, years_compare);

        })
    }

    jumpPeriodValid(type){
        if(type === "prev"){
            let from_current = new Date(this.state.datepicker.from)
            from_current.setDate(from_current.getDate() - this.state.days_pickup.range);  
            if(from_current.getFullYear() !== this.props.app.state.current_year){
                return " hide";
            }
        }else if(type === "next"){
            let to_current = new Date(this.state.datepicker.to)
            to_current.setDate(to_current.getDate() + this.state.days_pickup.range);  
            if(to_current.getFullYear() !== this.props.app.state.current_year){
                return " hide";
            }
        }
        return ""
    }
    render(){

    const listPeriods = periods.map((item, index) =>
        <li key={"list-periods-reserve-" + index} className={isSelected(item.value, this.state.current_period.value)} 
            onClick={this.handleClickMenuItem.bind(this, item.key, item.value,  "period_menu")}>
            {item.key}
        </li>
    );

    const listStatusReserve = status_reserve.map((item, index) =>
        <li key={"list-status-reserve-" + index} className={isSelected(item.value, this.state.current_status.value)} 
            onClick={this.handleClickMenuItem.bind(this, item.key, item.value,  "status_menu")}>
            {item.key}
        </li>
    );

    const listViews = views.map((item, index) =>
        <li key={"list-views-" + index} className={isSelected(item.value, this.state.current_view_review.value)} 
            onClick={this.handleClickMenuItem.bind(this, item.key, item.value,  "views_menu")}>
            {item.key}
        </li>
    );
    const listReservationViews = leadtime_chart.map((item, index) =>
        <li key={"list-reservation-" + index} className={isSelected(item.value, this.state.current_view_review.value)} 
            onClick={this.handleClickMenuItem.bind(this, item.key, item.value,  "reservation_chart_menu")}>
            {item.key}
        </li>
    );

    const listLeadtimeViews = leadtime_chart.map((item, index) =>
        <li key={"list-leadtime-" + index} className={isSelected(item.value, this.state.current_view_review.value)} 
            onClick={this.handleClickMenuItem.bind(this, item.key, item.value,  "leadtime_chart_menu")}>
            {item.key}
        </li>
    );

    const listYears= this.state.years.map((item, index) =>
        <li key={"list-year-" + index} className={isSelected(item, this.state.current_year.value)} 
            onClick={this.handleClickMenuItem.bind(this, item, item,  "comp_year")}>
            {item}
        </li>
    );
    const listYearsCompare= this.state.past_years.map((item, index) =>
        <li key={"list-year-compare-" + index} className={isSelected(item, this.state.current_year_compare.value)} 
            onClick={this.handleClickMenuItem.bind(this, item, item,  "comp_past_year")}>
            {item}
        </li>
    );
    const listDias = days.map((item, index) =>
        <li key={"list-days-" + index}>
            <span>{item.key}</span>
            <input type="checkbox" 
                value={ item.value }
                checked={isChecked(this.state.active_days, item.value)} 
                onClick={this.handleClickMenuItem.bind(this, item.key, item.value, "days")}
            />
            <span className="checkmark"></span>
        </li>
    );
    const listOptionsCompare = options_compare.map((item, index) =>
        <li key={"list-options-" + index} className={isSelected(item.value, this.state.current_view_review.value)} 
            onClick={this.handleClickMenuItem.bind(this, item.key, item.value,  "custom_compare")}>
            {item.key}
        </li>
    );
    if(this.state.datepicker.from !== undefined){
        var dateFormatFrom = new Date(this.state.datepicker.from);
        dateFormatFrom = dateFormatFrom.getFullYear() + "/" + months[dateFormatFrom.getMonth()] +  "/" + dateFormatFrom.getDate();
    }
    if(this.state.datepicker.to !== undefined){   
        var dateFormatTo = new Date(this.state.datepicker.to);
        dateFormatTo = dateFormatTo.getFullYear() + "/" + months[dateFormatTo.getMonth()] +  "/" + dateFormatTo.getDate();
    }
    return( <div></div>)}
};


export default FiltersTime


// WEBPACK FOOTER //
// ./src/Frontend/components/FiltersTime.js